function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "shift4-icon_svg__a",
  d: "M.06.796h146.281V147H.06z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "shift4-icon_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#shift4-icon_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M73.239.796A73.51 73.51 0 0059.1 2.167v16.276s28.788 2.268 32.15 34.14l26.998-36.29C105.84 6.584 90.216.796 73.239.796m48.553 27.991v18.127h-14.179l14.179-18.127",
  fill: "#0078AA",
  mask: "url(#shift4-icon_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.045 31.854v37.447h-11.546V55.418H74.883S75.904 31.62 49.019 31.62c-11.693 0-22.071 7.645-22.362 15.153-.585 12.186 16.664 18.268 34.783 21.951 10.664 2.128 22.069 7.514 26.74 13.608 6.574 8.633 5.994 17.278 5.994 17.278s2.19 27.617-35.074 33.285v12.734A73.51 73.51 0 0073.239 147c40.358 0 73.077-32.704 73.102-73.056-.038-2.957.775-21.938-13.296-42.09",
  fill: "#0078AA",
  mask: "url(#shift4-icon_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.621 32.78s-26.881 37.929-2.184 71.501c12.124 13.597 33.027 15.299 44.426 14.304 7.745-.707 12.86-3.252 15.784-5.806 5.697-4.955 11.395-14.586-3.507-23.507-17.098-9.918-46.325-6.381-55.676-26.773 0 0-6.569-11.211 1.157-29.719",
  fill: "#0078AA",
  mask: "url(#shift4-icon_svg__b)"
}));
function SvgShift4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 147 147"
  }, props), _ref, _ref2);
}
export default SvgShift4Icon;